import { lazy } from "react";

import SectionPage from "../CmsDocuments/SectionPage/SectionPage";
import UserGuideList from "../CmsDocuments/UserGuideList";
import ArticleGroup from "../CmsDocuments/ArticleGroup";
import AllQuestions from "../CmsDocuments/AllQuestions";
import Question from "../CmsDocuments/Question";

const BlankPage = lazy(() => import("../CmsDocuments/BlankPage"));
const DefaultGrid = lazy(() => import("../CmsDocuments/DefaultGrid"));
const Announcement = lazy(() => import("../CmsDocuments/Announcement"));

export const ResolveDocument = ({ cmsContent, settings }) => {
  switch (cmsContent?.documentType) {
    case "product":
    case "insurance":
    case "products":
    case "region":
    case "contentBase":
    case "customerService":
    case "customerServiceDefaultPage":
    case "gridDefaultPage":
    case "openingHours":
    case "campaign":
      return (
        <>
          {cmsContent.grid && (
            <DefaultGrid
              grid={cmsContent.grid}
              settings={settings}
              meta={cmsContent.meta}
              notificationList={cmsContent.notificationList}
            />
          )}
          {cmsContent.contentList && (
            <SectionPage
              contentList={cmsContent.contentList}
              layoutOverrides={cmsContent.layoutOverrides}
              notificationList={cmsContent.notificationList}
            />
          )}
        </>
      );

    case "blankTemplate":
      return <BlankPage cmsContent={cmsContent}></BlankPage>;
    case "articleGroup":
      return <ArticleGroup cmsContent={cmsContent} />;
    case "userGuide":
      return <UserGuideList cmsContent={cmsContent} />;
    case "qaList":
      return (
        <AllQuestions
          name={cmsContent.name}
          categoryList={cmsContent.categoryList || []}
          enableAccordianFaq={cmsContent.enableAccordianFaq ?? false}
        />
      );
    case "qA":
      return <Question question={cmsContent.question} answer={cmsContent.answer} />;
    case "announcement":
      return <Announcement />;
    case "sectionPage":
      return (
        <SectionPage
          articleSettings={cmsContent.articleSettings}
          contentList={cmsContent.contentList}
          layoutOverrides={cmsContent.layoutOverrides}
          notificationList={cmsContent.notificationList}
        />
      );
    default:
      return null;
  }
};
